const menu = {
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [],
  },
};

export default menu;
